import React from 'react';
import { iconProps } from '../Helper';

const UploadFilesIcon = ({className}:iconProps ) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="vuesax/linear/paperclip-2">
                <g id="paperclip-2">
                <path className={className} id="Vector" d="M12.3302 12.1519L9.86018 14.6219C8.49018 15.9919 8.49018 18.2019 9.86018 19.5719C11.2302 20.9419 13.4402 20.9419 14.8102 19.5719L18.7002 15.6819C21.4302 12.9519 21.4302 8.51188 18.7002 5.78188C15.9702 3.05188 11.5302 3.05188 8.80018 5.78188L4.56018 10.0219C2.22018 12.3619 2.22018 16.1619 4.56018 18.5119" stroke="white"  stroke-linecap="round"/>
            </g>
        </g>
</svg>
    );
};

export default UploadFilesIcon;